// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3ztPt","bigColWidth":"Table_bigColWidth__10kAE","biggerColWidth":"Table_biggerColWidth__ST7kD","row":"Table_row__2VV5Y","col":"Table_col__2Gz9i"};